module.exports = __webpack_public_path__ + "ba9bdfd795801a359af8a87703da67e7.pdf";